<template>
  <div>
    <carousel :perPage="1" :navigateTo="[]"  on-slide-changed="slideChange($index)">

      <slide>
        <div class="padding arch">
          <p>As the sun moves overhead I become more confident of my steps, and the ground beneath my feet becomes a reassurance.
          Passers by congregate here, their coats open, hand in hand and smiling at each other.
          They exhange no words, not as far as I can hear, but they walk together for companionship. I see one reach into a pocket, inside the coat and pull out a small package. This act is not unnoticed by his companion. He holds his hand out and takes the package.
          I reach inside my own coat and take hold of the book nestled there. I hadn't noticed its existence until this moment.</p>
      </div>
    </slide>

    <slide>
      <div class="padding arch">
        <p>
          I have no idea how long I have been carrying it.
        </p>
     </div>
    </slide>

    <slide>
      <div class="padding arch">
        <p ref="boxwatch" fade="click" speed="normal">
          I look at the book in my hands.<br>
          One face is printed black, the other white. Obversely set. Two books within one.<br>
          I turn the pages and trace words, which describe a city that is not the one I hear around me. It reads like fiction, like imagination.<br>
          And yet each place, each name and turn of phrase, all hook something in me as if trying to drag up memories from below dark water. <br>
          There are gaps in the pages, and there are sections that have been erased or hidden.<br>
          I fold the covers and begin walking again,<br>
          my fingers running along the spine, <br>
          and i think about gaps, <br>
          and about what's <a @click="fade">between them</a><br></p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
       </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {

    }
  },
  methods: {
    fade () {
      this.$emit('fade', ['boxwatch', 'normal'])
    }
  }
}
</script>

<style lang="css" scoped>
</style>
